import { DashboardDateRange } from '@features/dashboard/constants';

export enum LeadAnalyticsCriteria {
  DISTRIBUTION = 'distribution',
  CONVERSION = 'conversion'
}

export enum LeadView {
  LIST = 'list',
  ANALYTICS = 'analytics'
}

export const LEAD_VIEW_OPTIONS = [
  { id: LeadView.LIST, label: 'List' },
  { id: LeadView.ANALYTICS, label: 'Analytics' }
];

export const CONVERSION_TICKS = [0, 20, 40, 60, 80, 100];

export const ANALYTICS_VIEW_OPTIONS = [
  {
    id: LeadAnalyticsCriteria.CONVERSION,
    value: LeadAnalyticsCriteria.CONVERSION,
    label: 'Conversion'
  },
  {
    id: LeadAnalyticsCriteria.DISTRIBUTION,
    value: LeadAnalyticsCriteria.DISTRIBUTION,
    label: 'Distribution'
  }
];

export const EMPTY_DATE_RANGE: DashboardDateRange = {
  startDate: '',
  endDate: ''
};
